import { Component } from 'react';
import { PACKAGES } from './constants';
import PACKAGE_FEATURES, { PackageFeatures } from './package-features';

import TeamPackageHeader from '~pricing/components/TeamPackageHeader';
import EnterprisePackageHeader from '~pricing/components/EnterprisePackageHeader';
import PackageCta from '~pricing/components/PackageCta';
import EnterprisePackageCta from '~pricing/components/EnterprisePackageCta';

export interface SummaryPackage {
  features: PackageFeatures;
  headerRenderer: Component;
  footerRenderer: Component;
}

type SummaryPackageList = {
  [packageId: string]: SummaryPackage;
};

/**
 * This file contains default rendering configuration for each package that's displayed
 * on the pricing summary page. Each package summary config includes:
 * - `features`: An array of features to render in the package summary
 * - `headerRenderer`: The component to use for the package header.
 *                     This usually displays price and top CTA.
 * - `footerRenderer`: The component to use for the package footer.
 *                     This usually contains a CTA and any footnotes for the package
 *
 * Experiments can override these for custom rendering.
 * TODO (mhackmann): Actually allow experiments to override anything
 */

const SUMMARY_PAGE_RENDERERS: SummaryPackageList = Object.freeze({
  [PACKAGES.TeamAdvantage]: {
    features: PACKAGE_FEATURES[PACKAGES.TeamAdvantage],
    headerRenderer: TeamPackageHeader,
    footerRenderer: PackageCta
  },
  [PACKAGES.TeamPremier]: {
    features: PACKAGE_FEATURES[PACKAGES.TeamPremier],
    headerRenderer: TeamPackageHeader,
    footerRenderer: PackageCta
  },
  [PACKAGES.Enterprise]: {
    features: PACKAGE_FEATURES[PACKAGES.Enterprise],
    headerRenderer: EnterprisePackageHeader,
    footerRenderer: EnterprisePackageCta
  }
});

export default SUMMARY_PAGE_RENDERERS;
